import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ClientBoard } from '../../model/client-model/client-board';
import { PublishedBoardV3Data, PublishedBoardV4Data } from '../../services/backend/backend-published-board.types';
import { PublishedBoardsModule } from './published-boards-modules';
import { PublishedBoardState } from './published-boards.types';

export const publishedBoardsFacadeActions = createActionGroup({
  source: 'Published board Facade',
  events: {
    'Load published board': props<{ boardId: ClientBoard['id']; forceLoad?: boolean }>(),
    'Load published board data': props<{ boardId: ClientBoard['id']; module?: PublishedBoardsModule }>(),
  },
});

export const publishedBoardEffectsActions = createActionGroup({
  source: 'Board Effects',
  events: {
    'Set published board': props<{ publishedBoard: PublishedBoardState }>(),
    'Set published board data': props<{
      boardId: string;
      publishedBoardData: NonNullable<PublishedBoardV3Data | PublishedBoardV4Data>;
    }>(),
    'Set published board module data': props<{
      boardId: string;
      moduleData: NonNullable<any>;
      module: PublishedBoardsModule;
    }>(),
    'No changes': emptyProps(),
    Error: props<{ boardId: string; error: Error }>(),
  },
});
